import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compStatusTypes } from '../../Constants';

class Button extends Component {
    constructor(props) {
        super(props);
        this.handleOnClick = this.handleOnClick.bind(this);
        this.handleOnMouseDown = this.handleOnMouseDown.bind(this);
    }

    getButtonClassName() {
        return `button ${this.props.className}`;
    }

    handleOnClick(e) {
        if (
            this.props.status !== compStatusTypes.DISABLED &&
            this.props.status !== compStatusTypes.HIDDEN
        ) {
            this.props.onClick(e);
        }
    }

    handleOnMouseDown(e) {
        if (
            this.props.status !== compStatusTypes.DISABLED &&
            this.props.status !== compStatusTypes.HIDDEN
        ) {
            this.props.onMouseDown(e);
        }
    }
    createButtonContent() {
        let content = null;
        if (this.props.children) {
            content = this.props.children;
        } else if (this.props.text) {
            content = this.props.text;
        }
        return content;
    }

    render() {
        const { style } = this.props;
        return (
            <div
                style={style}
                className={this.getButtonClassName()}
                onClick={this.handleOnClick}
                onMouseDown={this.handleOnMouseDown}
            >
                {this.createButtonContent()}
            </div>
        );
    }
}

Button.displayName = 'Button';
Button.propTypes = {
    children: PropTypes.object,
    className: PropTypes.string,
    status: PropTypes.oneOf(Object.keys(compStatusTypes)),
    onClick: PropTypes.func,
    text: PropTypes.string,
};
Button.defaultProps = {
    className: '',
    status: compStatusTypes.ENABLED,
    onClick() {},
    onMouseDown() {},
    text: '',
};

export default Button;



// WEBPACK FOOTER //
// ./components/CommonSet/Button.js